import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

const UserProfileRoute = () => {
  const { userProfileData } = useSelector((state) => state.userProfile)
  const location = useLocation()
  const navigate = useNavigate()
  const lastAppliedPathRef = useRef(null)

  useEffect(() => {
    const storedUrl = userProfileData?.module_config?.find((module) =>
      module.module_link.includes(location.pathname),
    )
    if (!storedUrl) return

    // Normalize stored value
    const normalizeStoredPath = (url) => {
      if (!url) return ''
      return url
        .replace(/^#/, '') // remove leading "#"
        .replace(/^\/+/, '') // remove leading slashes
    }

    const normalizedPath = normalizeStoredPath(storedUrl.module_link)

    // Build full URL with current origin + "#/"
    const finalUrl = `${window.location.origin}/#/${normalizedPath}`

    // Current relative path (React Router gives without "#")
    const currentUrl = location.pathname + location.search

    // If already applied, don’t repeat
    if (lastAppliedPathRef.current === currentUrl) return

    // Compare against normalized path (not full origin)
    if (currentUrl !== `/${normalizedPath}`) {
      lastAppliedPathRef.current = `/${normalizedPath}`
      // Use window.location.assign to push absolute URL with "#"
      window.location.assign(finalUrl)
    } else {
      lastAppliedPathRef.current = currentUrl
    }
  }, [userProfileData, navigate, location.pathname, location.search])

  return null
}

export default UserProfileRoute
